import { FunctionComponent, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Stack, Text, Box, Flex, Tooltip } from "@chakra-ui/react";
import Joyride from "react-joyride";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";

import { ReactComponent as CaretDownIcon } from "src/assets/images/Dropdown.svg";
import { ReactComponent as CaretUpIcon } from "src/assets/images/dropdown_up.svg";
import BrandFavicon from "src/assets/images/brand_favicon.png";

import { SIDENAVS } from "src/Constant/sidenav";

import { Button } from "src/components";

type Props = {
  isOpen: boolean;
  currentIndex: number;
  handleRunTour: any;
  handleCloseTour: any;
  storedAccess: any;
  handleCollapse: () => void;
  isCollapse: boolean;
};

const host = window.location.host;

const tourBrandName = host === "intel.peleza.com" ? "AML" : "Radar";

const sumaryName = host === "intel.peleza.com" ? "AML Peleza" : "IDRadar";

export const steps = [
  {
    target: ".first-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          {tourBrandName} Spotlight
        </Text>
        <Text fontSize={"14px"} mt={2}>
          Keep yourself updated on {`${tourBrandName}'s`} latest happenings,
          what is new and other juicy offers here.
        </Text>
      </Box>
    ),
  },
  {
    target: ".second-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          Dashboard
        </Text>
        <Text fontSize={"14px"} mt={2}>
          See your activity summary, 5 most used APIs and a chart representation
          of your endpoints and APIs.
        </Text>
      </Box>
    ),
  },
  {
    target: ".third-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          {tourBrandName} Check
        </Text>
        <Text fontSize={"14px"} mt={2}>
          Run Manual AML, Sanction, PEP, FATF Checks and Identity Verifications
          here.
        </Text>
      </Box>
    ),
  },
  {
    target: ".fourth-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          Check History
        </Text>
        <Text fontSize={"14px"} mt={2}>
          Find all your {tourBrandName} Check history and status here.
        </Text>
      </Box>
    ),
  },
  {
    target: ".fifth-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          {tourBrandName} Rules
        </Text>
        <Text fontSize={"14px"} mt={2}>
          Find all your {tourBrandName} Rules here.
        </Text>
      </Box>
    ),
  },
  {
    target: ".sixth-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          Back Office
        </Text>
        <Text fontSize={"14px"} mt={2}>
          All alert records on Screening Alert, and User Monitoring are listed
          on this module.
        </Text>
      </Box>
    ),
  },
  {
    target: ".seventh-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          {tourBrandName} Analytics
        </Text>
        <Text fontSize={"14px"} mt={2}>
          View all your analytical records from Endpoints to Rules and all
          analytical summaries.
        </Text>
      </Box>
    ),
  },
  {
    target: ".eight-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          Wallet
        </Text>
        <Text fontSize={"14px"} mt={2}>
          All Subscriptions can be seen here.
        </Text>
      </Box>
    ),
  },
  {
    target: ".night-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          API Keys
        </Text>
        <Text fontSize={"14px"} mt={2}>
          Your Public and Private Keys can be seen here.
        </Text>
      </Box>
    ),
  },
  {
    target: ".tenth-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          Documentation
        </Text>
        <Text fontSize={"14px"} mt={2}>
          Get to know about our available API documentation.
        </Text>
      </Box>
    ),
  },
  {
    target: ".eleventh-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          Settings
        </Text>
        <Text fontSize={"14px"} mt={2}>
          Rules Score threshold can be configured here.
        </Text>
      </Box>
    ),
  },
  {
    target: ".twelveth-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          Activity Summary
        </Text>
        <Text fontSize={"14px"} mt={2}>
          Here is a summary of your major activities while on {sumaryName}.
        </Text>
      </Box>
    ),
  },
  {
    target: ".thirteenth-step",
    content: (
      <Box textAlign={"start"}>
        <Text as="h4" color={"primary"}>
          Switch users
        </Text>
        <Text fontSize={"14px"} mt={2}>
          You can easily switch to a different user at any time while on{" "}
          {sumaryName}.
        </Text>
      </Box>
    ),
  },
];

export const Desktop_Navigation: FunctionComponent<Props> = ({
  isOpen,
  currentIndex,
  handleRunTour,
  handleCloseTour,
  storedAccess,
  handleCollapse,
  isCollapse,
}) => {
  const host = window.location.host;

  const bottomRef = useRef(null);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  const { pathname } = useLocation();

  const current_path = pathname.split("/");

  const tenant = JSON.parse(localStorage.getItem("clu")); // tlogo means, tenant logo

  // const productLogo = tenant ? tenant.tlogo : "";

  const productLogo =
    "https://prembly-assets-migrated.s3.us-east-2.amazonaws.com/prembly_radar.png";

  const brandLogo = tenant ? tenant.tbrand : "";

  const hostUrl = tenant ? `https://${tenant.host}` : "";

  const brandName =
    host === "intel.peleza.com" ? "Peleza AML" : "IdentityRadar";

  const scrollToBottom = () => {
    if (bottomRef.current) {
      bottomRef?.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (currentStepIndex === 6) {
      scrollToBottom();
    }
  }, [currentStepIndex === 6]);

  const renderDropdownIcon = ({ dropdown, module }: any) => {
    if (dropdown) {
      return dropdown && pathname.includes(module) ? (
        <CaretUpIcon />
      ) : (
        <CaretDownIcon />
      );
    }
    return null;
  };

  const renderChildLinks = ({ dropdown, children, module }: any) => {
    if (dropdown && pathname.includes(module)) {
      return (
        <Box borderLeft={"1px solid rgba(0, 0, 0, 0.12)"} width={"70%"} ml={10}>
          {children?.map((childMenu: any) => (
            <Box
              my={2}
              borderLeft={
                pathname.includes(
                  childMenu?.name.toLowerCase().replace(" ", "-"),
                )
                  ? "2px solid #CF2CA0"
                  : "#6B778C"
              }
              pl={"5px"}
              ml={"-1.5px"}
            >
              <Link to={childMenu.path} key={childMenu.path}>
                <Text
                  fontSize={"12px"}
                  color={
                    pathname.includes(
                      childMenu?.name.toLowerCase().replace(" ", "-"),
                    )
                      ? "#CF2CA0"
                      : "#6B778C"
                  }
                >
                  {childMenu.name}
                </Text>
              </Link>
            </Box>
          ))}
        </Box>
      );
    }
    return null;
  };

  return (
    <>
      <Joyride
        steps={steps}
        continuous
        hideCloseButton
        scrollToFirstStep
        showSkipButton
        scrollOffset={40}
        run={isOpen}
        disableScrolling
        disableScrollParentFix
        disableOverlayClose
        spotlightClicks
        stepIndex={currentIndex}
        locale={{ last: " Done", next: "Next →" }}
        spotlightPadding={3}
        callback={(data) => {
          setCurrentStepIndex(data?.index);
        }}
        styles={{
          options: {
            primaryColor: "#251169",
          },
        }}
      />
      <Box
        as="aside"
        bg={"secondary"}
        h={"100vh"}
        pt={5}
        position={"fixed"}
        display={"flex"}
        flexDirection={"column"}
        w={isCollapse ? "5%" : "18%"}
        overflowY={"scroll"}
        className={isCollapse ? "expand" : ""}
      >
        <Box className="logo">
          <img
            src={BrandFavicon}
            alt="brand logo"
            width={"25px"}
            height={"100px"}
            style={{ objectFit: "cover", margin: "auto", textAlign: "center" }}
            className={isCollapse ? "favicon_small" : "favicon"}
          />
          <img
            src={productLogo}
            alt="brand logo"
            width={"150px"}
            height={"150px"}
            style={{
              objectFit: "contain",
              margin: "auto",
              textAlign: "center",
            }}
            className={!isCollapse ? "brand_full" : "brand_full_lg"}
          />
        </Box>
        <Box
          display={"flex"}
          flexDirection={"column"}
          flex={1}
          position={"relative"}
        >
          <Box w={"90%"} my={5} mx={"auto"} flex={1}>
            {SIDENAVS.slice(0, 7).map(
              ({
                name,
                icon,
                path,
                module,
                dropdown,
                children,
                className,
                is_beta,
              }) => (
                <>
                  <Link to={`${path}`} key={path}>
                    <Box
                      mx={"auto"}
                      my={".8em"}
                      px={4}
                      py={3}
                      w={"100%"}
                      bg={current_path.includes(module) ? "#E4DFF5" : ""}
                      borderRadius={current_path.includes(module) ? "24px" : ""}
                      _hover={{ bg: "#E4DFF5", borderRadius: "24px" }}
                      className={className}
                    >
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        className={
                          isCollapse
                            ? "navigation_menu_wrapper_sm"
                            : "navigation_menu_wrapper_lg"
                        }
                      >
                        <Box display={"flex"} gap={3}>
                          <img
                            src={icon}
                            alt={`${name} icon`}
                            style={{ width: "20px", height: "20px" }}
                          />
                          <Text
                            color="primary"
                            as={"p"}
                            fontSize={"14px"}
                            className={
                              isCollapse
                                ? "navigation_text_sm"
                                : "navigation_text_lg"
                            }
                          >
                            {name}
                            {is_beta && (
                              <Text
                                as={"span"}
                                ml={3}
                                backgroundColor={"#ffc107"}
                                fontSize={"12px"}
                                padding={"1px 10px"}
                                borderRadius={"4px"}
                              >
                                Beta
                              </Text>
                            )}
                          </Text>
                        </Box>
                        <Box className={isCollapse ? "icon_sm" : "icon_lg"}>
                          {renderDropdownIcon({ dropdown, module })}
                        </Box>
                      </Stack>
                    </Box>
                  </Link>
                  <Box className={isCollapse ? "icon_sm" : "icon_lg"}>
                    {renderChildLinks({ dropdown, children, module })}
                  </Box>
                </>
              ),
            )}
          </Box>
          <Box w={"90%"} my={5} mx={"auto"}>
            {SIDENAVS.slice(7).map(
              ({ name, icon, path, module, className }) => (
                <Link
                  to={name === "Documentation" ? path : `${path}`}
                  target={name === "Documentation" ? "_blank" : "_self"}
                  key={path}
                >
                  <Box
                    mx={"auto"}
                    my={".8em"}
                    px={4}
                    py={3}
                    w={"100%"}
                    bg={current_path.includes(module) ? "#E4DFF5" : ""}
                    borderRadius={current_path.includes(module) ? "24px" : ""}
                    _hover={{ bg: "#E4DFF5", borderRadius: "24px" }}
                    className={className}
                  >
                    <Stack direction={"row"}>
                      <img
                        src={icon}
                        alt={`${name} icon`}
                        style={{ width: "20px", height: "20px" }}
                      />
                      <Text
                        color="primary"
                        as={"p"}
                        fontSize={"14px"}
                        className={
                          isCollapse
                            ? "navigation_text_sm"
                            : "navigation_text_lg"
                        }
                      >
                        {name}
                      </Text>
                    </Stack>
                  </Box>
                </Link>
              ),
            )}
            <a
              href={hostUrl}
              style={{
                color: "#0B0A0A",
                font: "14px",
                padding: "15px 20px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                borderRadius: "8px",
                background: "#fff",
                marginTop: "5em",
              }}
            >
              Go to <img src={brandLogo} style={{ height: "20px" }} />
            </a>
          </Box>
          <Box ref={bottomRef} height={"50px"} />
        </Box>
        <Tooltip
          label={["Toggle navigation"]}
          placement="right"
          hasArrow
          cursor={"pointer"}
        >
          <Box className="collapse" onClick={handleCollapse}>
            {isCollapse ? (
              <span>
                <MdArrowForwardIos size={10} />
              </span>
            ) : (
              <span>
                <MdArrowBackIosNew size={10} />
              </span>
            )}
          </Box>
        </Tooltip>
      </Box>
      {!storedAccess.isStartedTourGuide && (
        <Box
          width={"30%"}
          margin={"auto"}
          position={"fixed"}
          bottom={5}
          left={"50%"}
          transform={"translate(-50%)"}
          borderRadius={"5px"}
          background={"#d7d7d7"}
          color={"#000"}
          padding={"10px 15px"}
          zIndex={20}
        >
          <Text fontSize={"13px"}>
            Want a quick tour of {brandName}? Learn about our features and
            optimize your experience.
          </Text>
          <Flex
            mt={4}
            mb={3}
            mx={0}
            justifyContent={"flex-end"}
            alignItems={"center"}
            gap={3}
          >
            <Button
              size="xs"
              label="Take a tour"
              variant="link"
              colorScheme="blue"
              handleClick={handleRunTour}
            />

            <Button
              size="xs"
              label="Dismiss"
              variant="link"
              colorScheme="blue"
              handleClick={handleCloseTour}
            />
          </Flex>
        </Box>
      )}
    </>
  );
};
